module.exports = __webpack_public_path__ + "static/media/icon_bullet_check.bcd0aaaa.svg";